import { Link } from "react-router-dom";

import { Item } from "../../redux/shop/shop.types";

import useStyles from "./special-shop.styles";

import HomeStepper from "../../components/home-stepper";
import CollectionItem from "../../components/collection-item";

const SpecialShopPage = ({
  collectionItems,
  petTypePath,
}: {
  collectionItems: Item[];
  petTypePath: string | undefined;
}) => {
  const classes = useStyles();

  return (
    <div className={classes.specialPageContainer}>
      <HomeStepper />
      <div className={classes.todaySpecial}>
        <div className={classes.todaySpecialTitle}>
          <span>Today's Special</span>
          <Link to={`/shop/special/today`}>Shop All</Link>
        </div>
        <div className={classes.todaySpecialBody}>
          {collectionItems
            .filter((_, index: number) => index < 10)
            .map((item) => (
              <CollectionItem key={item.id} item={item} />
            ))}
        </div>
      </div>
      <div className={classes.specialShopContainer}>
        <div>
          <div className={classes.specialShopContainerTitle}>
            <span>Shop Dog Special</span>
            <Link to={`/shop/special`}>Shop All</Link>
          </div>
          <div className={classes.specialShopContainerLinks}>
            <Link to={`/shop/pet/${petTypePath}/food/dryfood`}>
              <div />
              Dry Food
            </Link>
            <Link to={`/shop/pet/${petTypePath}/food/dryfood`}>
              <div />
              Dry Food
            </Link>
            <Link to={`/shop/pet/${petTypePath}/food/dryfood`}>
              <div />
              Dry Food
            </Link>
            <Link to={`/shop/pet/${petTypePath}/food/dryfood`}>
              <div />
              Dry Food
            </Link>
          </div>
        </div>
        <div>
          <div className={classes.specialShopContainerTitle}>
            <span>Shop Cat Special</span>
            <Link to={`/shop/special`}>Shop All</Link>
          </div>
          <div className={classes.specialShopContainerLinks}>
            <Link to={`/shop/pet/${petTypePath}/food/dryfood`}>
              <div />
              Dry Food
            </Link>
            <Link to={`/shop/pet/${petTypePath}/food/dryfood`}>
              <div />
              Dry Food
            </Link>
            <Link to={`/shop/pet/${petTypePath}/food/dryfood`}>
              <div />
              Dry Food
            </Link>
            <Link to={`/shop/pet/${petTypePath}/food/dryfood`}>
              <div />
              Dry Food
            </Link>
          </div>
        </div>
        <div>
          <div className={classes.specialShopContainerTitle}>
            <span>Shop Bird Special</span>
            <Link to={`/shop/special`}>Shop All</Link>
          </div>
          <div className={classes.specialShopContainerLinks}>
            <Link to={`/shop/pet/${petTypePath}/food/dryfood`}>
              <div />
              Dry Food
            </Link>
            <Link to={`/shop/pet/${petTypePath}/food/dryfood`}>
              <div />
              Dry Food
            </Link>
            <Link to={`/shop/pet/${petTypePath}/food/dryfood`}>
              <div />
              Dry Food
            </Link>
            <Link to={`/shop/pet/${petTypePath}/food/dryfood`}>
              <div />
              Dry Food
            </Link>
          </div>
        </div>
        <div>
          <div className={classes.specialShopContainerTitle}>
            <span>Shop Small Pets Special</span>
            <Link to={`/shop/special`}>Shop All</Link>
          </div>
          <div className={classes.specialShopContainerLinks}>
            <Link to={`/shop/pet/${petTypePath}/food/dryfood`}>
              <div />
              Dry Food
            </Link>
            <Link to={`/shop/pet/${petTypePath}/food/dryfood`}>
              <div />
              Dry Food
            </Link>
            <Link to={`/shop/pet/${petTypePath}/food/dryfood`}>
              <div />
              Dry Food
            </Link>
            <Link to={`/shop/pet/${petTypePath}/food/dryfood`}>
              <div />
              Dry Food
            </Link>
          </div>
        </div>
        <div>
          <div className={classes.specialShopContainerTitle}>
            <span>Shop Reptile Special</span>
            <Link to={`/shop/special`}>Shop All</Link>
          </div>
          <div className={classes.specialShopContainerLinks}>
            <Link to={`/shop/pet/${petTypePath}/food/dryfood`}>
              <div />
              Dry Food
            </Link>
            <Link to={`/shop/pet/${petTypePath}/food/dryfood`}>
              <div />
              Dry Food
            </Link>
            <Link to={`/shop/pet/${petTypePath}/food/dryfood`}>
              <div />
              Dry Food
            </Link>
            <Link to={`/shop/pet/${petTypePath}/food/dryfood`}>
              <div />
              Dry Food
            </Link>
          </div>
        </div>
        <div>
          <div className={classes.specialShopContainerTitle}>
            <span>Shop Fish Special</span>
            <Link to={`/shop/special`}>Shop All</Link>
          </div>
          <div className={classes.specialShopContainerLinks}>
            <Link to={`/shop/pet/${petTypePath}/food/dryfood`}>
              <div />
              Dry Food
            </Link>
            <Link to={`/shop/pet/${petTypePath}/food/dryfood`}>
              <div />
              Dry Food
            </Link>
            <Link to={`/shop/pet/${petTypePath}/food/dryfood`}>
              <div />
              Dry Food
            </Link>
            <Link to={`/shop/pet/${petTypePath}/food/dryfood`}>
              <div />
              Dry Food
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpecialShopPage;
